import api from './api.js'

// 消息列表
export function getIssueInvoiceList(params){
    return api.get('/resource-order/api/v1/issue/invoice/query',params);
}

export function getIssueInvoiceByUuid(uuid){
    return api.get(`/resource-order/api/v1/issue/invoice/${uuid}`);
}

export function saveIssueInvoiceByUuid(params){
    return api.post('/resource-order/api/v1/issue/invoice/save',params);
}
//根据订单获取开票信息
export function getIssueInvoiceByOrderId(uuid){
    return api.get(`/resource-order/api/v1/issue/invoice/getIssueInvoiceByOrderId/${uuid}`);
}



// WEBPACK FOOTER //
// ./src/utils/issueInvoice.js